import styled from 'styled-components';

export const ReceiptOverviewContainer = styled.div`
    width: 25rem;
`;
